/**
 * @module
 * @name Tooltip
 * @description Renders all nav items with router-links and different content
 *              related to, such as icons.
 */
export default {
  name: 'Tooltip',
  props: {
    textInfo: String
  },
  data: function () {
    return {
      isHintVisible: false
    }
  },
  methods: {
    showHint () {
      this.isHintVisible = true
      setTimeout(() => {
        this.isHintVisible = false
      }, 5000)
    }
  }
}
